/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    InternalApiExportFileType,
    InternalApiExportFileTypeFromJSON,
    InternalApiExportFileTypeToJSON,
    InternalApiFinalRisk,
    InternalApiFinalRiskFromJSON,
    InternalApiFinalRiskToJSON,
    InternalApiPersonRisks,
    InternalApiPersonRisksFromJSON,
    InternalApiPersonRisksToJSON,
} from '../models';

export interface ExportFinalRiskHistoryRequest {
    personId: string;
    fileType: InternalApiExportFileType;
}

export interface ExportFinalRiskHistoryResponse {
    headers: Headers;
    body: Blob;
}

export interface FindFinalRiskHistoryRequest {
    personId: string;
}

export interface GetPersonRisksInternalRequest {
    personId: string;
}

/**
 * 
 */
export class InternalRiskApi extends runtime.BaseAPI {

    /**
     * Exports the events as a file
     */
    async exportFinalRiskHistoryRaw(requestParameters: ExportFinalRiskHistoryRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.personId === null || requestParameters.personId === undefined) {
            throw new runtime.RequiredError('personId','Required parameter requestParameters.personId was null or undefined when calling exportFinalRiskHistory.');
        }

        if (requestParameters.fileType === null || requestParameters.fileType === undefined) {
            throw new runtime.RequiredError('fileType','Required parameter requestParameters.fileType was null or undefined when calling exportFinalRiskHistory.');
        }

        const queryParameters: any = {};

        if (requestParameters.fileType !== undefined) {
            queryParameters['fileType'] = requestParameters.fileType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/risk/final-risk/{personId}/export`.replace(`{${"personId"}}`, encodeURIComponent(String(requestParameters.personId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Exports the events as a file
     */
    async exportFinalRiskHistory(requestParameters: ExportFinalRiskHistoryRequest, initOverrides?: RequestInit): Promise<ExportFinalRiskHistoryResponse> {
        const response = await this.exportFinalRiskHistoryRaw(requestParameters, initOverrides);
        return {
          headers: response.raw.headers,
          body: await response.value(),
        };
    }

    /**
     * Fetches person final risk history (final risk records merged with override events)
     */
    async findFinalRiskHistoryRaw(requestParameters: FindFinalRiskHistoryRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<InternalApiFinalRisk>>> {
        if (requestParameters.personId === null || requestParameters.personId === undefined) {
            throw new runtime.RequiredError('personId','Required parameter requestParameters.personId was null or undefined when calling findFinalRiskHistory.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/risk/final-risk/{personId}`.replace(`{${"personId"}}`, encodeURIComponent(String(requestParameters.personId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InternalApiFinalRiskFromJSON));
    }

    /**
     * Fetches person final risk history (final risk records merged with override events)
     */
    async findFinalRiskHistory(requestParameters: FindFinalRiskHistoryRequest, initOverrides?: RequestInit): Promise<Array<InternalApiFinalRisk>> {
        const response = await this.findFinalRiskHistoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetch person risk factors
     */
    async getPersonRisksInternalRaw(requestParameters: GetPersonRisksInternalRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiPersonRisks>> {
        if (requestParameters.personId === null || requestParameters.personId === undefined) {
            throw new runtime.RequiredError('personId','Required parameter requestParameters.personId was null or undefined when calling getPersonRisksInternal.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/persons/{personId}/risks`.replace(`{${"personId"}}`, encodeURIComponent(String(requestParameters.personId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiPersonRisksFromJSON(jsonValue));
    }

    /**
     * Fetch person risk factors
     */
    async getPersonRisksInternal(requestParameters: GetPersonRisksInternalRequest, initOverrides?: RequestInit): Promise<InternalApiPersonRisks> {
        const response = await this.getPersonRisksInternalRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
